
import common from './common'
import ucadm from './ucadm'

export default {
    modules: {
        common,
        ucadm
    }
}